import { IonLoading } from "@ionic/react";

import "./WLLoader.scss";
import { useWLLoaderStore } from "./store";

export const WLLoader = () => {
  const [isLoading, message] = useWLLoaderStore((state) => [
    state.isLoading,
    state.message,
  ]);
  return (
    <IonLoading
      mode="ios"
      cssClass="wl-loader"
      isOpen={isLoading}
      spinner="crescent"
      message={message || ""}
    />
  );
};
